import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-budget-instructions',
  templateUrl: './budget-instructions.component.html',
  styleUrls: ['./budget-instructions.component.scss']
})
export class BudgetInstructionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
